<template>

	<v-container :class='$vuetify.breakpoint.mdAndDown ? "pa-0" : "pa-0 px-1"' fluid>
		<!-- Fix- or Flex-Durationfilter -->
		<v-container>
			<v-row>
				<v-col
					:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
					class='text-center'
					:cols='$vuetify.breakpoint.xsOnly ? 12 : 6'
					md='4'
				>

					<v-btn
						:depressed='isSelected(default_option_fixed)'
						:outlined='!isSelected(default_option_fixed)'
						block
						class='select_btn light-border br-3'
						color='primary'
						@click='optionClicked(default_option_fixed)'
					>
						{{ default_duration }}
					</v-btn>
				</v-col>

				<v-col
					v-for='option in duration_options'
					:key='option.value'
					:cols='filter.two_lines_mobile ? 6 : 12'
					:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
					class='text-center'
					md='4'
				>
					<v-btn
						:depressed='isSelected(option)'
						:outlined='!isSelected(option)'
						block
						:small='$vuetify.breakpoint.mdAndDown'
						class='select_btn light-border br-3'
						color='primary'
						@click='optionClicked(option)'
					>
						<div class='text-ellipsis' style='max-width: 100%'>
							{{ option.label }}
						</div>
					</v-btn>
				</v-col>

				<v-col
					cols='12'
					:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
					class='fixed-duration-info d-inline-flex'
				>
					<i class='far fa-info-circle' />
					<p> {{ duration_description }} </p>
				</v-col>
			</v-row>
		</v-container>
		<!-- Slider -->
		<div v-if='$vuetify.breakpoint.lgAndUp' class=''>
			<v-container :class='"pa-16 pb-10 mx-0 slider-container"'>
				<vue-slider
					v-model='selected'
					:duration='0.25'
					:process-style='{backgroundColor: getColor}'
					tooltip='none'
					v-bind='sliderOptions'
				>

					<template v-slot:dot='{ value, focus }'>
						<div :class='["slider-dot", { focus }]' :style='{"backgroundColor": getColor}'>
							<i class='fal fa-angle-left' />
							<i class='fal fa-angle-right' />
						</div>
					</template>

					<template v-slot:step='{ label, active }'>
						<div :class='["slider-step", { active }]' :style='{"color": active ? getColor : "#AAAAAA"}' />
					</template>

				</vue-slider>
				<v-row v-if='explanation' class='mt-5'>
					<svg
						height='45'
						style='margin-left: -0.5px'
						viewBox='0 0 512 512'
						width='45'
						xmlns='http://www.w3.org/2000/svg'
					>
						<path
							:fill='getExplanationColor'
							d='m365.291 168.033a295.963 295.963 0 0 0 -293.291 295.967 24 24 0 0 1 -48 0 343.66 343.66 0 0 1 341.376-343.968l31.958 23.968zm-14.891 91.167 128-96a24 24 0 0 0 0-38.4l-128-96a24 24 0 1 0 -28.8 38.4l102.4 76.8-102.4 76.8a24 24 0 1 0 28.8 38.4z'
						/>
					</svg>

					<div :style='{"color": getExplanationColor}' class='explanation ml-2' v-html='explanation' />
				</v-row>
			</v-container>
		</div>

		<div v-else v-resize='getRadius' style='position: relative; overflow: hidden'>

			<v-row align='center' justify='center' class='round-slider-container mb-4 mt-11'>
				<round-slider
					ref='slider1'
					v-model='roundSliderSelection'
					slider-type='min-range'
					circle-shape='pie'
					editable-tooltip='false'
					show-tooltip='true'
					:radius='getRadius()'
					width='7'
					handle-size='24'
					start-angle='-45'
					:min='0'
					:max='roundSliderValues.length - 1'
					:create='onSliderCreate'
					path-color='#999'
					:range-color='getColor'
					border-color='#000'
					border-width='0'
					line-cap='butt'
					animation='false'
					:tooltip-format='getExplanationFromTooltip'
				/>
			</v-row>

			<div
				v-if='roundSliderSelection === 0'
				style='height: 45px; text-align: center; bottom: 45px; position: absolute; width: 100%'
				class='hide-xxs-only'
			>
				<svg
					height='45'
					viewBox='0 0 512 512'
					width='45'
					xmlns='http://www.w3.org/2000/svg'
				>

					<path
						:fill='$vuetify.theme.themes.light.accent'
						d='m488 48a343 343 0 0 1 -100.755 243.245 342.834 342.834 0 0 1 -109.337 73.712 341.724 341.724 0 0 1 -131.285 27.011l-31.957-23.968 32.044-24.033a294 294 0 0 0 206.59-86.667 294.07 294.07 0 0 0 86.7-209.3 24 24 0 0 1 48 0zm-292.8 430.4a24 24 0 0 0 -4.8-33.6l-102.4-76.8 102.4-76.8a24 24 0 1 0 -28.8-38.4l-128 96a24 24 0 0 0 0 38.4l128 96a24 24 0 0 0 33.6-4.8z'
					/>

				</svg>

			</div>
		</div>
	</v-container>
</template>

<script>
import BaseFilterMixin from './BaseFilterMixin'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import RoundSlider from 'vue-round-slider'

export default {
	name: 'DurationFilter',
	components: {RoundSlider, VueSlider},
	mixins: [BaseFilterMixin],

	data() {
		const value = this.filter.values.find(f => f.default)
		return {
			default_option_fixed: undefined,
			selected_options: [],
			selected: undefined,
			roundSliderSelection: undefined,
			default_duration: value.default_duration,
			duration_description: value.duration_description,
      duration_options: []
		}
	},

	computed: {
		explanation() {
			const value = this.filter.values.find(obj => obj.value === this.selected)

			if (value && value.explanation) return value.explanation
			else return ''
		},

		getColor() {
			return this.getColorFrom('slider_color')
		},

		getExplanationColor() {
			return this.getColorFrom('explanation_color')
		},

		roundSliderValues() {
			const values = []

			const default_option = this.filter.values.find(f => f.default)

			values.push(Object.assign(default_option, {index: 0}))

			const options = this.filter.values.filter(f => !f.default)

			options.forEach((option, index) => {
				values.push(Object.assign(option, {index: index + 1}))
			})
			return values
		},

		sliderOptions() {
      let durationOptions = [...this.filter.values]
      durationOptions.sort((a, b) => {
        return a.label - b.label
      })
			return {
				data: durationOptions.map(obj => obj.value),
				marks: val => {
					const value = this.filter.values.find(obj => obj.value === val)

					return {
						label: value.label,
						labelStyle: {
							color: this.$vuetify.theme.themes.light[value.label_color] || value.label_color
						}
					}
				}
			}
		}
	},

	watch: {
		selected_options: {
			deep: true,
			handler() {
				if (!this.selected_options.length){
					this.selected_options.push(this.default_option_fixed)
				}

				this.updateFilter([this.selected_options[0], this.filter.values.find(obj => obj.value === this.selected)])
			}
		},

		selected(val) {
			this.updateFilter([this.selected_options[0], this.filter.values.find(obj => obj.value === val)])
		},

		roundSliderSelection(index) {
			this.selected = this.roundSliderValues.find(v => v.index === index).value

			if (this.$vuetify.breakpoint.mdAndDown) {
				const explplanation_el = document.querySelector('.round-slider-container .rs-tooltip-text')
				const handle_el = document.querySelector('.round-slider-container .rs-handle')

				this.$nextTick(() => {
					explplanation_el.innerHTML = this.explanation
					explplanation_el.style.color = this.getExplanationColor
					handle_el.style.backgroundColor = this.getColor
				})
			}
		}
	},


	mounted() {
    const default_option_fixed = this.filter.duration_options.find((o) => o.default);
    this.duration_options = this.filter.duration_options.filter(i => !i.default);

    if (!default_option_fixed) {
      console.warn('default option not specified for:', this.filter)
    }
    this.default_option_fixed = default_option_fixed

    this.selected_options = [default_option_fixed]

    if(this.filter.selectedValues) {
      this.selected_options = [this.filter.selectedValues[0]]
    }

		this.roundSliderSelection = 0
		if (this.filter.selectedValues && this.filter.selectedValues[1]) {
			const index = this.roundSliderValues.find(v => v.value === this.filter.selectedValues[1].value).index
			this.roundSliderSelection = index
		}
	},

	methods: {
		isSelected(elem) {
			return this.selected_options.filter(e => {
			  return e.value == elem.value
      }).length > 0
		},

		optionClicked(option) {
			const index = this.selected_options.indexOf(option)

			if (index === -1) {
				this.selected_options.splice(0, 1)
				this.selected_options.push(option)
			} else this.selected_options.splice(0, 1)
		},

		getColorFrom(prop) {
			let color = this.$vuetify.theme.themes.light.primary

			const value = this.filter.values.find(obj => obj.value === this.selected)

			if (value && value[prop]) color = this.$vuetify.theme.themes.light[value[prop]] || value[prop]

			return color
		},
		getRadius() {
			let radius = (window.innerWidth - 118) / 2

			if (this.$vuetify.breakpoint.smAndUp) radius = radius * 0.6

			if (window.innerWidth < 340) radius -= 20

			if (radius < 80) radius = 80

			return radius
		},

		onSliderCreate: function () {
			const obj = this.$refs.slider1.instance
			// logic for the number generation around the circle
			for (let i = 0; i <= obj.options.max; i += 1) {
				let angle = obj._valueToAngle(i)
				let numberTag = obj._addSeperator(angle, '')
				let number = numberTag.children().removeClass()

				const option = this.roundSliderValues.find(v => v.index === i)

				let className = 'rs-number'
				if (option.default) className = 'rs-default'

				if (option.label < 10) className += ' pl-1'

				// if (option === this.roundSliderValues[this.roundSliderValues.length - 1]) continue

				number.addClass(className).html(option.label).rsRotate(-angle)

				number[0].style.color = this.$vuetify.theme.themes.light[option.label_color] || option.label_color

				const self = this

				number[0].addEventListener('click', (e) => {
					self.roundSliderSelection = self.roundSliderValues.find(v => String(v.label) === e.target.innerText).index
				})
			}

			// to set the path segment
			/*const segment = obj.$path.getTotalLength() / this.roundSliderValues.length
			obj.$path.style.strokeDasharray = [segment, 0].join(' ')
			*/
			obj.$path.style.strokeDasharray = [obj.$path.getTotalLength(), 0].join(' ')
			// to set the path width
			obj.$path.style.strokeWidth = 5
		},

		getExplanationFromTooltip(tooltip) {
			const option = this.roundSliderValues.find(v => v.index === tooltip.value)

			if (option && option.explanation) return option.explanation
			else return this.roundSliderValues.find(v => v.default).explanation
		}
	}
}
</script>


<style>
.round-slider-container span.rs-number, .round-slider-container span.rs-default {
	position: absolute;
	top: -10px;
	left: -34px;
	font-size: 15px;
	font-weight: bold;
	z-index: 0;
}

.round-slider-container span.rs-default {
	top: -9px;
	left: -64px;
}

.round-slider-container span.rs-tooltip.rs-tooltip-text {
	font-size: 15px !important;
	word-break: break-word;
	overflow-wrap: break-word;
	padding: 0 20px;
	margin-top: 0 !important;
	margin-left: 0 !important;
	top: 38% !important;
	left: 0 !important;
	width: 100% !important;
	transform: translate(0, 0) !important;
}

</style>

<style scoped>
.slider-container svg {
	transform: rotate(270deg);
}

.explanation {
	font-weight: 600;
	margin-top: 19px;
	min-height: 39px;
}
.vue-slider {
	box-sizing: content-box !important;
}

.vue-slider *{
	box-sizing: inherit !important;
}

.fixed-duration-info {
	font-size: 12px;
}

.fixed-duration-info .fa-info-circle {
	padding: 3px 5px 0px 0px;
}

</style>
